<template>
  <a-card title="运营位管理">
    <a-tabs v-if="activeView === 'manage'" v-model:activeKey="activeTab">
      <a-tab-pane key="slots" tab="运营位管理">
        <a-space>
          <a-form layout="inline" :model="slotsFormSearch" style="margin: 10px auto;">
            <a-form-item label="标题" name="title">
              <a-input placeholder="标题" v-model:value="slotsFormSearch.title" />
            </a-form-item>
            <a-form-item label="地区" name="region_code">
              <a-select
                :allowClear="true"
                style="width: 100px;"
                v-model:value="slotsFormSearch.region_code"
                :options="NationCodes"
              />
            </a-form-item>
            <a-form-item label="状态" name="status">
              <a-select
                style="width: 100px;"
                v-model:value="slotsFormSearch.status"
                :options="slotsStatusOptions"
              />
            </a-form-item>
            <a-form-item label="位置" name="position">
              <a-select
                :allowClear="true"
                style="width: 100px;"
                v-model:value="slotsFormSearch.position"
                :options="slotPositionOptions"
              />
            </a-form-item>
            <a-form-item label="样式" name="style">
              <a-select
                :allowClear="true"
                style="width: 130px;"
                v-model:value="slotsFormSearch.style"
                :options="slotStyleOptions"
              />
            </a-form-item>
            <a-form-item>
              <a-button
                type="primary"
                html-type="submit"
                @click="handleSlotsTableChange()"
              >
                搜索
              </a-button>
            </a-form-item>
            <a-form-item>
              <a-button
                type="primary"
                @click="handleSlotsCreate"
              >
                新建
              </a-button>
            </a-form-item>
          </a-form>
        </a-space>

        <a-alert :message="slotsNoticeMessage" type="info" show-icon style="text-align: left;" />
        <a-table
          class="ant-table-striped"
          :row-key="record => record.id"
          :data-source="slotsDataSource"
          :columns="slotsColumns"
          :pagination="slotsPagination"
          :loading="slotsLoading"
          @change="handleSlotsTableChange"
          :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        >
          <template #operator_id="{ record }">
            <Username :user_id="record.operator_id" />
          </template>
          <template #region_code="{ record }">
            <RegionCode :region_code="record.region_code" />
          </template>
          <template #position="{ record }">
            <a-tag>{{ getSlotPositionLabel(record.position) }}</a-tag>
          </template>
          <template #sorted="{ record }">
            <a-input-group compact style="width: 130px;">
              <a-input v-model:value="record.sorted" style="width: 60px;" />
              <a-button type="primary" @click="handleSlotsModifySort(record)">设置</a-button>
            </a-input-group>
          </template>
          <template #status="{ record }">
            <a-tag v-if="record.status == 1" color="green">已上线</a-tag>
            <a-tag v-if="record.status == 0" color="gray">已下线</a-tag>
            <a-tag v-if="record.status == 2" color="yellow">测试环境</a-tag>
          </template>
          <template #action="{ record }">
            <a-space>
              <a-button @click="handleSlotsModifyStatus(record, 1)" v-if="record.status == 0 || record.status == 2" type="primary">上线</a-button>
              <a-button @click="handleSlotsModifyStatus(record, 2)" v-if="record.status == 0" warning>测试环境</a-button>
              <a-button @click="handleSlotsModifyStatus(record, 0)" v-if="record.status == 1 || record.status == 2" danger>下线</a-button>
              <a-button @click="handleSlotsUpdate(record)">编辑</a-button>
              <a-button v-if="record.style === 'scene_layout'" href="https://admin.xuantu.pro/home/template_scene" target="_blank" rel="noopener noreferrer">查看卡片</a-button>
              <a-button v-else @click="handleViewSlotCards(record)">查看卡片</a-button>
              <a-popconfirm
                title="确定删除吗?"
                ok-text="确定"
                cancel-text="取消"
                @confirm="handleSlotsDelete(record)"
              >
                <a-button danger>删除</a-button>
              </a-popconfirm>
            </a-space>
          </template>
        </a-table>

        <a-modal v-model:open="slotsOpenDia" :title="slotsFormRecord.id == 0 ? '新建运营位' : '编辑运营位'" @cancel="resetSlotsForm" @ok="handleSlotsConfirm" :confirm-loading="slotsLoading">
          <a-form :label-col="{ span: 8 }" :model="slotsFormRecord" style="margin: 10px auto;" :rules="slotsRules" ref="slotsFormRef">
            <a-form-item required label="标题" name="title">
              <a-input placeholder="标题" v-model:value="slotsFormRecord.title" />
            </a-form-item>
            <a-form-item label="国际化标题" name="title_i18n">
              <Inputi18nInline showTitle="true" v-model:valid="slotsFormRecord.title_i18n_valid" v-model:value="slotsFormRecord.title_i18n" />
            </a-form-item>
            <a-form-item required label="样式" name="style">
              <a-select
                style="width: 160px;"
                v-model:value="slotsFormRecord.style"
                :options="slotStyleOptions"
              />
            </a-form-item>
            <a-form-item required label="位置" name="position">
              <a-select
                style="width: 160px;"
                v-model:value="slotsFormRecord.position"
                :options="slotPositionOptions"
              />
            </a-form-item>
            <a-form-item label="卡片IDs" name="card_ids">
              <a-input placeholder="卡片IDs，逗号分隔" v-model:value="slotsFormRecord.card_ids" :disabled="slotsFormRecord.style === 'scene_layout'" />
              <a-alert
                v-if="slotsFormRecord.style === 'scene_layout'"
                class="form-item-alert"
                type="info"
                show-icon
              >
                <template #message>
                  热门场景只占位置，内容请去"场景模板管理"配置。
                  <a href="https://admin.xuantu.pro/home/template_scene" target="_blank" rel="noopener noreferrer">场景模板配置</a>
                </template>
              </a-alert>
              <a-alert
                v-else
                class="form-item-alert"
                message="运营位的地区需要与卡片的地区在同一地区，否则无法展示！"
                type="warning"
                show-icon
              />
            </a-form-item>
            <a-form-item required label="排序" name="sorted">
              <a-input placeholder="排序" v-model:value="slotsFormRecord.sorted" type="number" />
            </a-form-item>
            <a-form-item required label="地区" name="region_code">
              <a-select
                style="width: 100px;"
                v-model:value="slotsFormRecord.region_code"
                :options="NationCodes"
              />
            </a-form-item>
          </a-form>
        </a-modal>
      </a-tab-pane>
      <a-tab-pane key="cards" tab="运营卡片管理">
        <a-space>
          <a-form layout="inline" :model="cardsFormSearch" style="margin: 10px auto;">
            <a-form-item label="标题" name="title">
              <a-input placeholder="标题" v-model:value="cardsFormSearch.title" />
            </a-form-item>
            <a-form-item label="地区" name="region_code">
              <a-select
                :allowClear="true"
                style="width: 100px;"
                v-model:value="cardsFormSearch.region_code"
                :options="NationCodes"
              />
            </a-form-item>
            <a-form-item label="状态" name="status">
              <a-select
                style="width: 100px;"
                v-model:value="cardsFormSearch.status"
                :options="cardsStatusOptions"
              />
            </a-form-item>
            <a-form-item label="跳转目标" name="route_target">
              <a-select
                :allowClear="true"
                style="width: 110px;"
                v-model:value="cardsFormSearch.route_target"
                :options="routeTargetOptions"
              />
            </a-form-item>
            <a-form-item>
              <a-button
                type="primary"
                html-type="submit"
                @click="handleCardsTableChange()"
              >
                搜索
              </a-button>
            </a-form-item>
            <a-form-item>
              <a-button
                type="primary"
                @click="handleCardsCreate"
              >
                新建
              </a-button>
            </a-form-item>
          </a-form>
        </a-space>

        <a-alert :message="cardsNoticeMessage" type="info" show-icon style="text-align: left;" />
        <a-table
          class="ant-table-striped"
          :row-key="record => record.id"
          :data-source="cardsDataSource"
          :columns="cardsColumns"
          :pagination="cardsPagination"
          :loading="cardsLoading"
          @change="handleCardsTableChange"
          :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        >
          <template #operator_id="{ record }">
            <Username :user_id="record.operator_id" />
          </template>
          <template #region_code="{ record }">
            <RegionCode :region_code="record.region_code" />
          </template>
          <template #cover="{ record }">
            <a-image
              style="width: 100px;"
              :src="rawImage(record.cover)"
              width="100"
            />
          </template>
          <template #route_target="{ record }">
            <a-tag>{{ getRouteTargetLabel(record.route_target) }}</a-tag>
          </template>
          <template #route_value="{ record }">
            <span v-if="record.route_target === 'tool'">Tool_id:{{ record.tool_id || '-' }}</span>
            <span v-else-if="record.route_target === 'tab'">Tool_id:{{ record.tool_id || '-' }} / Tab_id:{{ record.tab_id || '-' }}</span>
            <span v-else-if="record.route_target === 'template'">Tool_id:{{ record.tool_id || '-' }} / Tab_id:{{ record.tab_id || '-' }} / 模板ID: {{ record.template_id || '-' }}</span>
            <span v-else>-</span>
          </template>
          <template #sorted="{ record }">
            <a-input-group compact style="width: 130px;">
              <a-input v-model:value="record.sorted" style="width: 60px;" />
              <a-button type="primary" @click="handleCardsModifySort(record)">设置</a-button>
            </a-input-group>
          </template>
          <template #status="{ record }">
            <a-tag v-if="record.status == 1" color="green">已上线</a-tag>
            <a-tag v-if="record.status == 0" color="gray">已下线</a-tag>
          </template>
          <template #action="{ record }">
            <a-space>
              <a-button @click="handleCardsModifyStatus(record, 1)" v-if="record.status == 0" type="primary">上线</a-button>
              <a-button @click="handleCardsModifyStatus(record, 0)" v-if="record.status == 1" danger>下线</a-button>
              <a-button @click="handleCardsUpdate(record)">编辑</a-button>
              <a-popconfirm
                title="确定删除吗?"
                ok-text="确定"
                cancel-text="取消"
                @confirm="handleCardsDelete(record)"
              >
                <a-button danger>删除</a-button>
              </a-popconfirm>
            </a-space>
          </template>
        </a-table>

        <a-modal v-model:open="cardsOpenDia" :title="cardsFormRecord.id == 0 ? '新建运营卡片' : '编辑运营卡片'" @cancel="resetCardsForm" @ok="handleCardsConfirm" :confirm-loading="cardsLoading">
          <a-form :label-col="{ span: 8 }" :model="cardsFormRecord" style="margin: 10px auto;" :rules="cardsRules" ref="cardsFormRef">
            <a-form-item required label="标题" name="title">
              <a-input placeholder="标题" v-model:value="cardsFormRecord.title" />
            </a-form-item>
            <a-form-item label="国际化标题" name="title_i18n">
              <Inputi18nInline showTitle="true" v-model:valid="cardsFormRecord.title_i18n_valid" v-model:value="cardsFormRecord.title_i18n" />
            </a-form-item>
            <a-form-item required label="封面" name="cover">
              <Upload v-model:imageUrl="cardsFormRecord.cover" />
              <a-input placeholder="封面URL" v-model:value="cardsFormRecord.cover" />
            </a-form-item>
            <a-form-item label="动画前景图" name="cover_blind">
              <Upload v-model:imageUrl="cardsFormRecord.cover_blind" />
              <a-input placeholder="动画前景图URL" v-model:value="cardsFormRecord.cover_blind" />
            </a-form-item>
            <a-form-item required label="排序" name="sorted">
              <a-input placeholder="排序" v-model:value="cardsFormRecord.sorted" type="number" />
            </a-form-item>
            <a-form-item required label="地区" name="region_code">
              <a-select
                style="width: 100px;"
                v-model:value="cardsFormRecord.region_code"
                :options="NationCodes"
              />
            </a-form-item>
            <a-form-item required label="ToolID" name="tool_id">
              <a-select
                show-search
                option-filter-prop="label"
                placeholder="请选择 ToolID"
                style="width: 200px;"
                v-model:value="cardsFormRecord.tool_id"
                :options="ToolIDOptions"
                @change="handleCardsToolChange"
              />
            </a-form-item>
            <a-form-item required label="跳转目标" name="route_target">
              <a-select
                style="width: 160px;"
                v-model:value="cardsFormRecord.route_target"
                :options="routeTargetOptions"
                @change="handleCardsRouteTargetChange"
              />
              <a-alert
                class="form-item-alert"
                message="非编辑器的工具跳转选非编辑器工具"
                type="warning"
                show-icon
              />
            </a-form-item>
            <a-form-item v-if="cardsFormRecord.route_target === 'tab'" required label="TabID" name="tab_id">
              <a-space class="template-select-row">
                <a-select
                  v-if="cardTabOptions.length > 0 || cardsFormRecord.tab_id"
                  show-search
                  placeholder="请选择 Tab"
                  style="width: 180px;"
                  v-model:value="cardsFormRecord.tab_id"
                  :options="cardTabOptions"
                />
                <a-button type="primary" @click="loadCardTabs">加载</a-button>
              </a-space>
            </a-form-item>
            <a-form-item v-if="cardsFormRecord.route_target === 'template'" required label="模板" name="template_id">
              <a-space class="template-select-row">
                <a-select
                  v-if="cardTemplateOptions.length > 0 || cardsFormRecord.template_id"
                  show-search
                  placeholder="请选择模板"
                  style="width: 180px;"
                  v-model:value="cardsFormRecord.template_id"
                  :options="cardTemplateOptions"
                  @change="handleCardTemplateChange"
                />
                <a-button type="primary" @click="loadCardTemplates">加载</a-button>
              </a-space>
            </a-form-item>
            <a-form-item v-if="cardsFormRecord.route_target === 'template'" label="TabID" name="tab_id">
              <a-input placeholder="选择模板后自动填充" v-model:value="cardsFormRecord.tab_id" disabled />
            </a-form-item>
          </a-form>
        </a-modal>
      </a-tab-pane>
    </a-tabs>
    <div v-else>
      <a-space style="margin: 10px auto;">
        <a-button type="primary" @click="handleBackToSlots">返回运营位管理</a-button>
        <span>运营位：{{ slotCardsRecord.title || '-' }}（ID: {{ slotCardsRecord.id || '-' }}）</span>
        <a-input-group compact style="width: 390px;">
          <a-input
            v-model:value="slotCardsAppendIDs"
            placeholder="增加卡片ID，多个用,隔开"
            style="width: 260px;"
          />
          <a-button type="primary" @click="handleAddSlotCards">增加卡片</a-button>
        </a-input-group>
      </a-space>
      <a-alert
        message="运营位必须与卡片是一样的地区，否则无法展示。"
        type="warning"
        show-icon
        style="text-align: left; margin-bottom: 8px;"
      />
      <a-alert :message="slotCardsNoticeMessage" type="info" show-icon style="text-align: left;" />
      <a-table
        class="ant-table-striped"
        :row-key="record => record.id"
        :data-source="slotCardsDataSource"
        :columns="slotCardsColumns"
        :pagination="false"
        :loading="slotCardsLoading"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
        <template #operator_id="{ record }">
          <Username :user_id="record.operator_id" />
        </template>
        <template #region_code="{ record }">
          <RegionCode :region_code="record.region_code" />
        </template>
        <template #cover="{ record }">
          <a-image
            style="width: 100px;"
            :src="rawImage(record.cover)"
            width="100"
          />
        </template>
        <template #route_target="{ record }">
          <a-tag>{{ getRouteTargetLabel(record.route_target) }}</a-tag>
        </template>
        <template #route_value="{ record }">
          <span v-if="record.route_target === 'tool'">{{ record.tool_id || '-' }}</span>
          <span v-else-if="record.route_target === 'tab'">{{ record.tab_id || '-' }}</span>
          <span v-else-if="record.route_target === 'template'">TabID: {{ record.tab_id || '-' }} / 模板ID: {{ record.template_id || '-' }}</span>
          <span v-else>-</span>
        </template>
        <template #status="{ record }">
          <a-tag v-if="record.status == 1" color="green">已上线</a-tag>
          <a-tag v-if="record.status == 0" color="gray">已下线</a-tag>
        </template>
        <template #slot_cards_action="{ record }">
          <a-popconfirm
            title="确定从运营位移除吗?"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDeleteSlotCard(record)"
          >
            <a-button danger>移除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { defineComponent } from 'vue'
import { message } from 'ant-design-vue'
import request from '@/utils/request'
import Upload from '@/components/Upload.vue'
import Username from '@/components/Username.vue'
import RegionCode from '@/components/RegionCode.vue'
import Inputi18nInline from '@/components/Inputi18nInline.vue'
import { NationCodes, ToolIDOptions } from '@/utils/macro'
import { generateRandomString } from '@/utils/string'
import { thumbnail, rawImage, removeHost } from '@/utils/image'

const DefaultCardRecord = {
  id: 0,
  title: '',
  title_i18n: '',
  title_i18n_valid: false,
  cover: '',
  cover_blind: '',
  status: 0,
  sorted: 100,
  region_code: '',
  route_target: 'tool',
  tool_id: '',
  tab_id: '',
  template_id: ''
}

const DefaultSlotRecord = {
  id: 0,
  title: '',
  title_i18n: '',
  title_i18n_valid: false,
  position: 'home',
  style: 'row_layout',
  status: 0,
  card_ids: '',
  sorted: 100,
  region_code: ''
}

export default defineComponent({
  components: {
    Upload, Username, Inputi18nInline, RegionCode
  },
  data() {
    return {
      NationCodes,
      ToolIDOptions,
      activeTab: 'slots',
      activeView: 'manage',
      slotsLoading: false,
      slotsOpenDia: false,
      slotsDataSource: [],
      slotsFormRecord: {
        ...DefaultSlotRecord
      },
      slotsRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'change' },
        ],
        style: [
          { required: true, message: '请选择样式', trigger: 'change' },
        ],
        position: [
          { required: true, message: '请选择位置', trigger: 'change' },
        ],
        sorted: [
          { required: true, message: '请输入排序', trigger: 'change' },
        ],
        region_code: [
          { required: true, message: '请选择地区', trigger: 'change' },
        ],
      },
      slotsPagination: {
        total: 1,
        current: 1,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      slotsNoticeMessage: '',
      slotCardsLoading: false,
      slotCardsDataSource: [],
      slotCardsRecord: {},
      slotCardsAppendIDs: '',
      slotCardsNoticeMessage: '',
      cardsLoading: false,
      cardsOpenDia: false,
      cardsDataSource: [],
      cardTabOptions: [],
      cardTemplateOptions: [],
      cardTemplateMap: {},
      cardsFormRecord: {
        ...DefaultCardRecord
      },
      cardsRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'change' },
        ],
        sorted: [
          { required: true, message: '请输入排序', trigger: 'change' },
        ],
        region_code: [
          { required: true, message: '请选择地区', trigger: 'change' },
        ],
        route_target: [
          { required: true, message: '请选择跳转目标', trigger: 'change' },
        ],
        tool_id: [
          { required: true, message: '请选择 ToolID', trigger: 'change' },
        ],
      },
      cardsPagination: {
        total: 1,
        current: 1,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      cardsNoticeMessage: '',
      slotsStatusOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '已下线',
          value: '0'
        },
        {
          label: '已上线',
          value: '1'
        },
        {
          label: '测试环境',
          value: '2'
        },
      ],
      cardsStatusOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '已下线',
          value: '0'
        },
        {
          label: '已上线',
          value: '1'
        },
      ],
      routeTargetOptions: [
        {
          label: '工具',
          value: 'tool'
        },
        {
          label: 'Tab',
          value: 'tab'
        },
        {
          label: '模板',
          value: 'template'
        },
        {
          label: '非编辑器工具',
          value: 'shortcut'
        },
      ],
      slotStyleOptions: [
        {
          label: '热门场景',
          value: 'scene_layout'
        },
        {
          label: '中卡片',
          value: 'medium_row_layout'
        },
        {
          label: '横向布局',
          value: 'row_layout'
        },
        {
          label: '混排',
          value: 'mixed_layout'
        },
        {
          label: '大横排',
          value: 'large_row_layout'
        },
        {
          label: '列表',
          value: 'list_layout'
        },
      ],
      slotPositionOptions: [
        {
          label: '首页',
          value: 'home'
        },
        {
          label: '导出页',
          value: 'guide'
        },
      ],
      slotsFormSearch: {
        title: '',
        status: '',
        region_code: '',
        position: '',
        style: '',
      },
      cardsFormSearch: {
        title: '',
        status: '',
        region_code: '',
        route_target: '',
      },
    }
  },
  mounted() {
    this.handleSlotsTableChange()
    this.handleCardsTableChange()
  },
  methods: {
    normalizeInt(value) {
      const parsed = parseInt(value)
      return Number.isNaN(parsed) ? 0 : parsed
    },
    buildCardsPayload() {
      return {
        title: this.cardsFormRecord.title,
        title_i18n: this.cardsFormRecord.title_i18n,
        cover: removeHost(this.cardsFormRecord.cover),
        cover_blind: removeHost(this.cardsFormRecord.cover_blind),
        sorted: this.normalizeInt(this.cardsFormRecord.sorted),
        region_code: this.cardsFormRecord.region_code,
        route_target: this.cardsFormRecord.route_target,
        tool_id: this.cardsFormRecord.tool_id,
        tab_id: ['tab', 'template'].includes(this.cardsFormRecord.route_target) ? this.normalizeInt(this.cardsFormRecord.tab_id) : 0,
        template_id: this.cardsFormRecord.route_target === 'template' ? this.normalizeInt(this.cardsFormRecord.template_id) : 0,
      }
    },
    buildSlotsPayload() {
      return {
        title: this.slotsFormRecord.title,
        title_i18n: this.slotsFormRecord.title_i18n,
        position: this.slotsFormRecord.position,
        style: this.slotsFormRecord.style,
        status: this.normalizeInt(this.slotsFormRecord.status),
        card_ids: this.slotsFormRecord.style === 'scene_layout' ? '' : this.slotsFormRecord.card_ids,
        sorted: this.normalizeInt(this.slotsFormRecord.sorted),
        region_code: this.slotsFormRecord.region_code,
      }
    },
    async handleSlotsConfirm() {
      this.slotsLoading = true
      try {
        if (!this.slotsFormRecord.title_i18n_valid) {
          message.error('请填写国际化标题')
          return false
        }
        const payload = this.buildSlotsPayload()
        if (this.slotsFormRecord.id) {
          await request.put(`/api/op_slots/${this.slotsFormRecord.id}`, payload)
        } else {
          await request.post('/api/op_slots/', payload)
        }
        message.success(this.slotsFormRecord.id ? '编辑成功' : '创建成功')
        this.slotsOpenDia = false
        this.handleSlotsTableChange(this.slotsPagination)
      } catch (error) {
        message.error('操作失败')
      } finally {
        this.slotsLoading = false
      }
    },
    handleSlotsCreate() {
      this.slotsOpenDia = true
      const i18nkey = `op_slot.title.${generateRandomString()}`
      this.slotsFormRecord = { ...DefaultSlotRecord, title_i18n: i18nkey, title_i18n_valid: false }
    },
    handleSlotsUpdate(record) {
      this.slotsOpenDia = true
      this.slotsFormRecord = {
        ...DefaultSlotRecord,
        ...record,
        title_i18n_valid: !!record.title_i18n,
      }
    },
    async handleSlotsDelete(record) {
      this.slotsLoading = true
      try {
        await request.delete(`/api/op_slots/${record.id}`)
        message.success('删除成功')
        this.handleSlotsTableChange(this.slotsPagination)
      } catch (error) {
        message.error('删除失败')
      } finally {
        this.slotsLoading = false
      }
    },
    async handleSlotsModifySort(record) {
      this.slotsLoading = true
      try {
        await request.put(`/api/op_slots/${record.id}`, {
          sorted: this.normalizeInt(record.sorted)
        })
        message.success('排序更新成功')
        this.handleSlotsTableChange(this.slotsPagination)
      } catch (error) {
        message.error('排序更新失败')
      } finally {
        this.slotsLoading = false
      }
    },
    async handleSlotsModifyStatus(record, status) {
      this.slotsLoading = true
      try {
        await request.put(`/api/op_slots/${record.id}`, {
          status: parseInt(status)
        })
        message.success('状态更新成功')
        this.handleSlotsTableChange(this.slotsPagination)
      } catch (error) {
        message.error('状态更新失败')
      } finally {
        this.slotsLoading = false
      }
    },
    async handleViewSlotCards(record) {
      this.slotCardsRecord = { ...record }
      this.activeView = 'slotCards'
      this.activeTab = 'slots'
      this.slotCardsLoading = true
      try {
        const rsp = await request.get(`/api/op_slots/${record.id}/cards`, {
          region_code: record.region_code,
        })
        if (rsp && rsp.data) {
          this.slotCardsDataSource = rsp.data.cards || []
          for (let v of this.slotCardsDataSource) {
            v.cover = rawImage(v.cover)
            v.cover_blind = rawImage(v.cover_blind)
          }
          this.slotCardsNoticeMessage = `共 ${this.slotCardsDataSource.length} 条`
        } else {
          this.slotCardsDataSource = []
          this.slotCardsNoticeMessage = '共 0 条'
        }
      } catch (error) {
        this.slotCardsDataSource = []
        this.slotCardsNoticeMessage = '共 0 条'
        message.error('加载卡片失败')
      } finally {
        this.slotCardsLoading = false
      }
    },
    async handleAddSlotCards() {
      const appendIDs = `${this.slotCardsAppendIDs || ''}`
        .split(/[,，]/)
        .map(item => item.trim())
        .filter(item => item)
      if (appendIDs.length === 0) {
        message.error('请输入卡片ID')
        return
      }
      const existingIDs = `${this.slotCardsRecord.card_ids || ''}`
        .split(/[,，]/)
        .map(item => item.trim())
        .filter(item => item)
      const nextCardIDs = Array.from(new Set([...existingIDs, ...appendIDs])).join(',')

      this.slotCardsLoading = true
      try {
        await request.put(`/api/op_slots/${this.slotCardsRecord.id}`, {
          card_ids: nextCardIDs
        })
        message.success('增加卡片成功')
        this.slotCardsAppendIDs = ''
        this.slotCardsRecord.card_ids = nextCardIDs
        await this.handleViewSlotCards(this.slotCardsRecord)
        this.handleSlotsTableChange(this.slotsPagination)
      } catch (error) {
        message.error('增加卡片失败')
      } finally {
        this.slotCardsLoading = false
      }
    },
    async handleDeleteSlotCard(record) {
      const existingIDs = `${this.slotCardsRecord.card_ids || ''}`
        .split(/[,，]/)
        .map(item => item.trim())
        .filter(item => item)
      const nextCardIDs = existingIDs.filter(item => item !== `${record.id}`).join(',')

      this.slotCardsLoading = true
      try {
        await request.put(`/api/op_slots/${this.slotCardsRecord.id}`, {
          card_ids: nextCardIDs
        }, '')
        message.success('移除卡片成功')
        this.slotCardsRecord.card_ids = nextCardIDs
        await this.handleViewSlotCards(this.slotCardsRecord)
      } catch (error) {
        message.error('移除卡片失败')
      } finally {
        this.slotCardsLoading = false
      }
    },
    handleBackToSlots() {
      this.activeView = 'manage'
      this.activeTab = 'slots'
      this.slotCardsDataSource = []
      this.slotCardsRecord = {}
      this.slotCardsAppendIDs = ''
      this.slotCardsNoticeMessage = ''
    },
    resetSlotsForm() {
      this.slotsFormRecord = { ...DefaultSlotRecord }
      this.$refs.slotsFormRef.resetFields()
    },
    async handleSlotsTableChange(pagination = { current: 1, pageSize: 20 }) {
      this.slotsLoading = true
      try {
        const rsp = await request.get('/api/op_slots/', {
          offset: (pagination.current - 1) * pagination.pageSize,
          limit: pagination.pageSize,
          ...this.slotsFormSearch
        })

        if (rsp && rsp.data) {
          this.slotsDataSource = rsp.data.list || []
          if (rsp.data.pagination) {
            this.slotsNoticeMessage = `共 ${rsp.data.pagination.total || 0} 条`
            this.slotsPagination.total = rsp.data.pagination.total || 0
          } else {
            this.slotsNoticeMessage = '共 0 条'
            this.slotsPagination.total = 0
          }
        } else {
          this.slotsDataSource = []
          this.slotsNoticeMessage = '共 0 条'
          this.slotsPagination.total = 0
        }
        this.slotsPagination.current = pagination.current
        this.slotsPagination.pageSize = pagination.pageSize
      } catch (error) {
        this.slotsDataSource = []
        this.slotsNoticeMessage = '共 0 条'
        this.slotsPagination.total = 0
      } finally {
        this.slotsLoading = false
      }
    },
    validateCardsRoute() {
      if (!this.cardsFormRecord.tool_id) {
        message.error('请选择 ToolID')
        return false
      }
      if (this.cardsFormRecord.route_target === 'tab' && !this.normalizeInt(this.cardsFormRecord.tab_id)) {
        message.error('请选择 TabID')
        return false
      }
      if (this.cardsFormRecord.route_target === 'template' && !this.normalizeInt(this.cardsFormRecord.template_id)) {
        message.error('请选择模板')
        return false
      }
      if (this.cardsFormRecord.route_target === 'template' && !this.normalizeInt(this.cardsFormRecord.tab_id)) {
        message.error('请选择带 TabID 的模板')
        return false
      }
      return true
    },
    getRouteTargetLabel(routeTarget) {
      const found = this.routeTargetOptions.find(item => item.value === routeTarget)
      return found ? found.label : routeTarget || '-'
    },
    getSlotPositionLabel(position) {
      const found = this.slotPositionOptions.find(item => item.value === position)
      return found ? found.label : position || '-'
    },
    async handleCardsConfirm() {
      this.cardsLoading = true
      try {
        if (!this.cardsFormRecord.title_i18n_valid) {
          message.error('请填写国际化标题')
          return false
        }
        if (!this.cardsFormRecord.cover) {
          message.error('请输入封面')
          return false
        }
        if (!this.validateCardsRoute()) {
          return false
        }
        const payload = this.buildCardsPayload()
        if (this.cardsFormRecord.id) {
          await request.put(`/api/op_slots_cards/${this.cardsFormRecord.id}`, payload)
        } else {
          await request.post('/api/op_slots_cards/', payload)
        }
        message.success(this.cardsFormRecord.id ? '编辑成功' : '创建成功')
        this.cardsOpenDia = false
        this.handleCardsTableChange(this.cardsPagination)
      } catch (error) {
        message.error('操作失败')
      } finally {
        this.cardsLoading = false
      }
    },
    handleCardsCreate() {
      this.cardsOpenDia = true
      const i18nkey = `op_slot_card.title.${generateRandomString()}`
      this.cardTabOptions = []
      this.cardTemplateOptions = []
      this.cardTemplateMap = {}
      this.cardsFormRecord = { ...DefaultCardRecord, title_i18n: i18nkey, title_i18n_valid: false }
    },
    handleCardsUpdate(record) {
      this.cardsOpenDia = true
      this.cardTabOptions = []
      this.cardTemplateOptions = []
      this.cardTemplateMap = {}
      this.cardsFormRecord = {
        ...DefaultCardRecord,
        ...record,
        title_i18n_valid: !!record.title_i18n,
        tab_id: record.tab_id ? `${record.tab_id}` : '',
        template_id: record.template_id ? `${record.template_id}` : '',
      }
    },
    handleCardsToolChange() {
      this.cardsFormRecord.tab_id = ''
      this.cardsFormRecord.template_id = ''
      this.cardTabOptions = []
      this.cardTemplateOptions = []
      this.cardTemplateMap = {}
    },
    handleCardsRouteTargetChange() {
      this.cardsFormRecord.tab_id = ''
      this.cardsFormRecord.template_id = ''
    },
    async loadCardTabs() {
      if (!this.cardsFormRecord.tool_id) {
        message.error('请先选择 ToolID')
        return
      }
      this.cardsLoading = true
      try {
        const resp = await request.get('/api/creation/option_tabs', {
          tool_id: this.cardsFormRecord.tool_id,
          limit: 999,
        })
        this.cardTabOptions = []
        if (resp.data.list) {
          for (let v of resp.data.list) {
            this.cardTabOptions.push({
              label: `${v.tab_name || '-'} (${v.id})`,
              value: v.id,
            })
          }
        }
        if (this.cardTabOptions.length > 0 && !this.cardsFormRecord.tab_id) {
          this.cardsFormRecord.tab_id = this.cardTabOptions[0].value
        }
      } finally {
        this.cardsLoading = false
      }
    },
    async loadCardTemplates() {
      if (!this.cardsFormRecord.tool_id) {
        message.error('请先选择 ToolID')
        return
      }
      this.cardsLoading = true
      try {
        const resp = await request.get('/api/creation/options', {
          tool_id: this.cardsFormRecord.tool_id,
          limit: 999,
        })
        this.cardTemplateOptions = []
        this.cardTemplateMap = {}
        if (resp.data.list) {
          for (let v of resp.data.list) {
            this.cardTemplateMap[v.id] = v
            this.cardTemplateOptions.push({
              label: `${v.title || v.name || '-'} (${v.id})`,
              value: v.id,
            })
          }
        }
        if (this.cardTemplateOptions.length > 0 && !this.cardsFormRecord.template_id) {
          this.cardsFormRecord.template_id = this.cardTemplateOptions[0].value
          this.handleCardTemplateChange(this.cardsFormRecord.template_id)
        }
      } finally {
        this.cardsLoading = false
      }
    },
    handleCardTemplateChange(templateID) {
      const template = this.cardTemplateMap[templateID]
      if (template) {
        this.cardsFormRecord.tab_id = template.tab_id ? `${template.tab_id}` : ''
      }
    },
    async handleCardsDelete(record) {
      this.cardsLoading = true
      try {
        await request.delete(`/api/op_slots_cards/${record.id}`)
        message.success('删除成功')
        this.handleCardsTableChange(this.cardsPagination)
      } catch (error) {
        message.error('删除失败')
      } finally {
        this.cardsLoading = false
      }
    },
    async handleCardsModifySort(record) {
      this.cardsLoading = true
      try {
        await request.put(`/api/op_slots_cards/${record.id}`, {
          sorted: this.normalizeInt(record.sorted)
        })
        message.success('排序更新成功')
        this.handleCardsTableChange(this.cardsPagination)
      } catch (error) {
        message.error('排序更新失败')
      } finally {
        this.cardsLoading = false
      }
    },
    async handleCardsModifyStatus(record, status) {
      this.cardsLoading = true
      try {
        await request.put(`/api/op_slots_cards/${record.id}`, {
          status: parseInt(status)
        })
        message.success('状态更新成功')
        this.handleCardsTableChange(this.cardsPagination)
      } catch (error) {
        message.error('状态更新失败')
      } finally {
        this.cardsLoading = false
      }
    },
    resetCardsForm() {
      this.cardsFormRecord = { ...DefaultCardRecord }
      this.$refs.cardsFormRef.resetFields()
    },
    async handleCardsTableChange(pagination = { current: 1, pageSize: 20 }) {
      this.cardsLoading = true
      try {
        const params = {
          offset: (pagination.current - 1) * pagination.pageSize,
          limit: pagination.pageSize,
          ...this.cardsFormSearch,
        }
        const rsp = await request.get('/api/op_slots_cards/', params)

        if (rsp && rsp.data) {
          this.cardsDataSource = rsp.data.list || []
          for (let v of this.cardsDataSource) {
            v.cover = rawImage(v.cover)
            v.cover_blind = rawImage(v.cover_blind)
          }
          if (rsp.data.pagination) {
            this.cardsNoticeMessage = `共 ${rsp.data.pagination.total || 0} 条`
            this.cardsPagination.total = rsp.data.pagination.total || 0
          } else {
            this.cardsNoticeMessage = '共 0 条'
            this.cardsPagination.total = 0
          }
        } else {
          this.cardsDataSource = []
          this.cardsNoticeMessage = '共 0 条'
          this.cardsPagination.total = 0
        }
        this.cardsPagination.current = pagination.current
        this.cardsPagination.pageSize = pagination.pageSize
      } catch (error) {
        this.cardsDataSource = []
        this.cardsNoticeMessage = '共 0 条'
        this.cardsPagination.total = 0
      } finally {
        this.cardsLoading = false
      }
    },
  },
  setup() {
    return {
      thumbnail,
      rawImage,
      slotsColumns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '标题',
          dataIndex: 'title',
          key: 'title',
        },
        {
          title: '样式',
          dataIndex: 'style',
          key: 'style',
        },
        {
          title: '位置',
          dataIndex: 'position',
          key: 'position',
          slots: { customRender: 'position' },
        },
        {
          title: '地区',
          dataIndex: 'region_code',
          key: 'region_code',
          slots: { customRender: 'region_code' },
        },
        {
          title: '排序',
          slots: { customRender: 'sorted' },
          width: 130,
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          slots: { customRender: 'status' },
        },
        {
          title: '修改时间',
          dataIndex: 'updated_at',
          key: 'updated_at',
        },
        {
          title: '操作人ID',
          dataIndex: 'operator_id',
          key: 'operator_id',
          slots: {
            customRender: 'operator_id'
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
      cardsColumns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '标题',
          dataIndex: 'title',
          key: 'title',
        },
        {
          title: '封面',
          dataIndex: 'cover',
          key: 'cover',
          slots: { customRender: 'cover' },
        },
        {
          title: '地区',
          dataIndex: 'region_code',
          key: 'region_code',
          slots: { customRender: 'region_code' },
        },
        {
          title: '跳转目标',
          dataIndex: 'route_target',
          key: 'route_target',
          slots: { customRender: 'route_target' },
        },
        {
          title: '跳转值',
          dataIndex: 'route_value',
          key: 'route_value',
          slots: { customRender: 'route_value' },
        },
        {
          title: '排序',
          slots: { customRender: 'sorted' },
          width: 130,
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          slots: { customRender: 'status' },
        },
        {
          title: '修改时间',
          dataIndex: 'updated_at',
          key: 'updated_at',
        },
        {
          title: '操作人ID',
          dataIndex: 'operator_id',
          key: 'operator_id',
          slots: {
            customRender: 'operator_id'
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
      slotCardsColumns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '标题',
          dataIndex: 'title',
          key: 'title',
        },
        {
          title: '封面',
          dataIndex: 'cover',
          key: 'cover',
          slots: { customRender: 'cover' },
        },
        {
          title: '地区',
          dataIndex: 'region_code',
          key: 'region_code',
          slots: { customRender: 'region_code' },
        },
        {
          title: '跳转目标',
          dataIndex: 'route_target',
          key: 'route_target',
          slots: { customRender: 'route_target' },
        },
        {
          title: '跳转值',
          dataIndex: 'route_value',
          key: 'route_value',
          slots: { customRender: 'route_value' },
        },
        {
          title: '排序',
          dataIndex: 'sorted',
          key: 'sorted',
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          slots: { customRender: 'status' },
        },
        {
          title: '修改时间',
          dataIndex: 'updated_at',
          key: 'updated_at',
        },
        {
          title: '操作人ID',
          dataIndex: 'operator_id',
          key: 'operator_id',
          slots: {
            customRender: 'operator_id'
          }
        },
        {
          title: '操作',
          dataIndex: 'slot_cards_action',
          key: 'slot_cards_action',
          slots: { customRender: 'slot_cards_action' },
        },
      ],
    }
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

.template-select-row {
  max-width: 260px;
  flex-wrap: wrap;
}

.form-item-alert {
  margin-top: 8px;
  max-width: 420px;
}
</style>
